import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';

import styles from './VpMediaViewList.module.less';
import VpMediaIcon from '../VpMediaIcon';

const VpMediaViewListItem = ({ media, onClick, selectedMediaId, mediaLabel }) => {
  const id = media?.mediaId || media?.attachmentId;

  const classNames = `
      ${styles.vpMediaContainer} 
      ${id === selectedMediaId ? styles.vpActiveMediaView : ''}
    `;

  const handleClick = () => {
    onClick(media);
  };

  return (
    <Box>
      <Box className={classNames} onClick={handleClick}>
        <VpMediaIcon media={media} className={styles.vpMediaViewItem} />
      </Box>
      <Chip label={mediaLabel} />
    </Box>
  );
};

VpMediaViewListItem.propTypes = {
  media: PropTypes.PropTypes.object.isRequired,
  selectedMediaId: PropTypes.string,
  onClick: PropTypes.func,
  mediaLabel: PropTypes.string
};
export default VpMediaViewListItem;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpMediaViewList/VpMediaViewListItem.jsx